
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/concepts/architecture-considerations",
      function () {
        return require("private-next-pages/docs/concepts/architecture-considerations.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/concepts/architecture-considerations"])
      });
    }
  